import { Check } from "lucide-react";
import { STEP_LABELS } from "@/lib/api";

export const Ticks = ({ sid, progress, compact = false }) => (
  <ul className={compact ? "flex flex-wrap gap-x-5 gap-y-2" : "space-y-2"}>
    {STEP_LABELS.map(([step, label]) => {
      const done = progress && progress[step];
      return (
        <li key={step} className="flex items-center gap-2.5" data-testid={`tick-${sid}-${step}`} data-done={done ? "true" : "false"}>
          <span className={`tick ${done ? "on" : ""}`}><Check size={15} strokeWidth={3} /></span>
          <span className={`text-[17px] ${done ? "font-bold" : "text-[#505a5f]"}`}>{label}</span>
        </li>
      );
    })}
  </ul>
);
